<template>
  <div class="reverso-user-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="100px" inline>
        <el-col :span="24">
<!--        <el-form-item label="用户类型">-->
<!--          <el-select v-model="queryParams.userType" size="small" clearable placeholder="请选择用户类型">-->
<!--            <el-option-->
<!--                v-for="subItem in enumUser"-->
<!--                :key="subItem.value"-->
<!--                :label="subItem.name"-->
<!--                :value="subItem.value"/>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
          <el-form-item label="产品名称">
            <el-input v-model="queryParams.productName" size="small" placeholder="请输入用户名称"></el-input>
          </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model="queryParams.userName" size="small" placeholder="请输入用户名称"></el-input>
        </el-form-item>
          <el-form-item label="用户类型">
            <el-select v-model="queryParams.userType" size="small" clearable placeholder="请选择用户类型">
              <el-option
                  v-for="subItem in enumUser"
                  :key="subItem.value"
                  :label="subItem.name"
                  :value="subItem.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
        <el-form-item label="用户地址">
          <el-input v-model="queryParams.userAddr" size="small" placeholder="请输入用户地址"></el-input>
        </el-form-item>
          <el-form-item label="经销商名称">
            <el-input v-model="queryParams.provideName" size="small" placeholder="请输入经销商名称"></el-input>
          </el-form-item>
          <el-form-item label="水泵码">
            <el-input v-model="queryParams.waterPumpCode" size="small" placeholder="请输入水泵码"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" style="display:flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;">
          <el-form-item label="销售时间">
            <el-date-picker
                v-model="dateSetting"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" round icon="el-icon-search" @click="getPageList()">搜索</el-button>
          <el-button round size="small" @click="onClickClear">重置</el-button>
          <el-button round size="small" @click="onClickDown">导出</el-button>
        </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="userName"
              show-overflow-tooltip
              align="center"
              width="100"
              label="用户名称">
          </el-table-column>
          <el-table-column
              prop="userType"
              show-overflow-tooltip
              align="center"
              width="100"
              label="用户类型">
          </el-table-column>
          <el-table-column
              prop="userPhone"
              show-overflow-tooltip
              align="center"
              width="150"
              label="联系电话">
          </el-table-column>
          <el-table-column
              prop="province"
              show-overflow-tooltip
              align="center"
              width="180"
              label="地区">
            <template slot-scope="scope">
              {{scope.row.province+"_"+scope.row.city+"_"+scope.row.are}}
            </template>
          </el-table-column>
          <el-table-column
              prop="userAddr"
              show-overflow-tooltip
              align="center"
              width="200"
              label="地址">
          </el-table-column>
          <el-table-column
              prop="productName"
              show-overflow-tooltip
              align="center"
              width="200"
              label="规格型号">
          </el-table-column>
          <el-table-column
              prop="provideName"
              show-overflow-tooltip
              align="center"
              width="300"
              label="经销商">
          </el-table-column>
          <el-table-column
              prop="waterPumpCode"
              show-overflow-tooltip
              align="center"
              width="300"
              label="水泵码">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              width="160"
              label="填写时间">
          </el-table-column>
          <el-table-column
              prop="desct"
              show-overflow-tooltip
              align="center"
              width="300"
              label="备注">
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="onChangeCurrent($event,1)"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            :page-sizes="pageSizes"
            background
            layout="total, prev, pager, next, sizes"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
  </div>
</template>

<script>

import {downTemplateUser, getTemplateUser} from "../../utils/interface";

export default {
  components: {},
  data() {
    return {
      pageSizes: [10,20,50,100,500],
      tableData: [],
      dateSetting:[],
      queryParams: {
        userName: '',
        productName: '',
        userType: '',
        productType: '',
        userAddr: '',
        provideName: '',
        provideUuid: '',
        waterPumpCode:'',
        province:'',
        startDate: '',
        endDate: '',
        current: 1,
        pageSize: 5,
        total: 0,
      },
      enumUser: [{
        value: '个人',
        name: '个人',
      }, {
        value: '公司',
        name: '公司',
      }, {
        value: '政府',
        name: '政府',
      }, {
        value: '事业单位',
        name: '事业单位',
      }],
      enumProduct: [{
        value: '-1',
        name: '请选择',
      }],
      listLoading: false,
      isProvide: false,
    };
  },
  created() {

  },
  methods: {
    initData(isProvide) {
      this.isProvide = isProvide
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      if (this.dateSetting.length>0){
        this.queryParams.startDate = this.dateSetting[0]
        this.queryParams.endDate = this.dateSetting[1]
      }
      this.listLoading = true
      if (this.isProvide){
        this.queryParams.provideUuid = this.$store.state.isUsermessage.uuid
      }
      getTemplateUser(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    onClickDown(){
      if (this.dateSetting.length>0){
        this.queryParams.startDate = this.dateSetting[0]
        this.queryParams.endDate = this.dateSetting[1]
      }
      this.listLoading = true
      downTemplateUser(this.queryParams).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        let num = ''
        for(let i=0;i < 10;i++){
          num += Math.ceil(Math.random() * 10)
        }
        link.setAttribute('download', '用户信息.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {

    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.dateSetting=[];
      this.queryParams = {
        userName: '',
        userType: '',
        productType: '',
        userAddr: '',
        provideName: '',
        provideUuid: '',
        waterPumpCode:'',
        startDate: '',
        endDate: '',
        current: 1,
        pageSize: 5,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e, type) {
      if (type === 1) {
        this.queryParams.current = e
        this.getPageList()
      }
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize
      // 在此刷新数据
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumUser.find(item => item.value === status).name
    },
  },
};
</script>

<style scoped lang="less">
.reverso-user-list {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoUserList.vue